import axios from 'axios';

export const FETCH_LIST_START = 'FETCH_LIST_START';

export const FETCH_LIST_SUCCESS = 'FETCH_LIST_SUCCESS';

export const FETCH_LIST_ERROR = 'FETCH_LIST_ERROR';

export function createFetchListStartAction() {
  return {
    type: FETCH_LIST_START
  };
}

export function createFetchListErrorAction(error) {
  return {
    type: FETCH_LIST_ERROR,
    payload: {
      error: error
    }
  };
}

export function createFetchListSucccessAction(data) {
  return {
    type: FETCH_LIST_SUCCESS,
    payload: {
      list: data.children,
      numberOfWishes: data.numberOfWishes,
      numberOfFulfilledWishes: data.numberOfFulfilledWishes
    }
  };
}

export function fetchChildrenList() {
  return dispatch => {
    dispatch(createFetchListStartAction());
    axios
      .get(process.env.REACT_APP_API_URL + '/api/v1/child')
      .then(response => {
        if (response.status !== 200) {
          dispatch(createFetchListErrorAction(response.error));
          return;
        }
        dispatch(createFetchListSucccessAction(response.data));
      })
      .catch(error => {
        dispatch(createFetchListErrorAction('CONNECTION_ERROR'));
      });
  };
}



// WEBPACK FOOTER //
// ./src/Actions/ChildrenList.js